import { render } from "./UploadShareholders.vue?vue&type=template&id=53e88de4"
import script from "./UploadShareholders.vue?vue&type=script&lang=js"
export * from "./UploadShareholders.vue?vue&type=script&lang=js"

import "./UploadShareholders.vue?vue&type=style&index=0&id=53e88de4&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__